import Pusher from 'pusher-js';
export default new Pusher('051ae8e925ea8ed904c2', {
  cluster: 'mt1',
  forceTLS: true,
});
